import classNames from 'classnames';
import BodyText from '../../../atoms/BodyText';
import React from 'react';
import Title from '../../../atoms/Title';
import Icon from '../../../atoms/Icon';
import * as styles from './companyProfileFeatures.linaria';
import CompanyProfileLink from '../CompanyProfileLink';
function CompanyProfileFeatures({ company, className, linkComponent, }) {
    var _a;
    return (<div className={classNames([styles.featureWrapper, className])}>
      <Title size="small" className="feature-title-wrapper">
        Tjenestetilbud
      </Title>

      {(company === null || company === void 0 ? void 0 : company.features) ? ((_a = company === null || company === void 0 ? void 0 : company.features) === null || _a === void 0 ? void 0 : _a.map((value) => {
            return (<CompanyProfileLink key={value === null || value === void 0 ? void 0 : value.featureName} url={value === null || value === void 0 ? void 0 : value.url} openInNewTab linkComponent={linkComponent}>
              <BodyText tag="span">
                {value === null || value === void 0 ? void 0 : value.featureName}
                {linkComponent && <Icon className="arrow-icon" icon="ArrowRight" size="xs"/>}
              </BodyText>
            </CompanyProfileLink>);
        })) : (<>
          <BodyText tag="span" size="medium" className="textLine empty-error-message-wrapper">
            Mangler informasjon
          </BodyText>
        </>)}
    </div>);
}
CompanyProfileFeatures.defaultProps = {
    className: null,
    linkComponent: null,
};
export default CompanyProfileFeatures;
